<template>
  <div>
    <v-layout class="mt-2 mb-2">
      <v-flex xs6>
        <BuscaSimplesApi
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/corteetario"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi"
        >
          <template slot-scope="propSlot">
            <span>{{ propSlot.item.identificadoretapaescolar + '/' + propSlot.item.anoinicioregracorte}}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" label @change="selectBuscaChange"/>
      </v-flex>
    </v-layout>
    <v-alert
      type="error"
      :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0"
      style="color: white;"
    >
      <div v-if="$v.$invalid && $v.$dirty">Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao"
      :id="form.identificadorcorteetario"
      :novo="novo"
      :editar="editar"
      :excluir="excluir"
      :cancelar="cancelar"
      :submit="submit"
    >
      <v-card>
        <v-card-text>
          <Input type="text" label="Código" v-model="form.identificadorarcorteetario" disabled/>

          <!-- Etapa escolar -->
          <v-layout align-center class="field100">
            <v-flex>
              <Input
                type="text"
                label="Etapa"
                ref="focusCampo"
                class="input-100"
                autofocus
                :value="aux.etapaescolar ? aux.etapaescolar + '  (' + aux.codigoetapa + ')' : ''"
                disabled
                :v="$v.form.identificadoretapaescolar"
              />
            </v-flex>
            <v-flex fill-height style="flex:0; margin-left: 5px;margin-bottom: 10px;">
              <v-btn
                class="rounded-sm font-weight-regular"
                style="margin: auto; top: 50%"
                color="primary"
                :loading="etapaloading"
                @click="buscarEtapa"
                :disabled="acao == '' || acao == 'editar'"
              >Buscar Etapa</v-btn>
            </v-flex>
          </v-layout>

          <!-- Ano de início da regra -->
          <Input
            type="number"
            label="Ano de início da regra"
            v-model="form.anoinicioregracorte"
            :min="currentYear"
            :disabled="!acao"
            :v="$v.form.anoinicioregracorte"
          />

          <!-- Idade mínima -->
          <v-flex>
            <Input
              type="number"
              label="Idade mínima"
              v-if="tipoidademinima==='mes'"
              v-model.number="form.quantidademesidademinimacorte"
              key="quantidademesidademinimacorte"
              :disabled="!acao"
              :v="$v.form.quantidademesidademinimacorte"
            />
            <Input
              type="number"
              label="Idade mínima"
              v-else
              v-model.number="form.quantidadeanoidademinimacorte"
              key="quantidadeanoidademinima"
              :disabled="!acao"
              :v="$v.form.quantidadeanoidademinimaidademinimacorte"
            />
            <Validator :v="$v.tipoidademinima">
              <v-radio-group style="margin-top: 0;" row v-model="tipoidademinima" :disabled="!acao">
                <v-radio
                  :ripple="false"
                  :label="form.quantidademesidademinimacorte > 1 ? 'Meses' : 'Mês'"
                  value="mes"
                />
                <v-radio
                  :ripple="false"
                  :label="form.quantidadeanoidademinimacorte > 1 ? 'Anos' : 'Ano'"
                  value="ano"
                />
              </v-radio-group>
            </Validator>
          </v-flex>

          <v-layout class="field100">
            <v-flex>
              <span class="v-label">Dia</span>
              <Select
                class="input-100 pr-3"
                :options="dias"
                v-model="form.diacorteetario"
                :disabled="acao==''"
                :v="$v.form.diacorteetario"
              />
            </v-flex>
            <v-flex>
              <span class="v-label">Mês</span>
              <Select
                class="input-100"
                :options="meses"
                v-model="form.mescorteetario"
                :disabled="acao==''"
                :v="$v.form.mescorteetario"
              />
            </v-flex>
          </v-layout>

          <!-- Idade máxima -->
          <v-flex>
            <Input
              type="number"
              label="Idade máxima"
              v-if="tipoidademaxima === 'mes'"
              v-model.number="form.quantidademesidademaximacorte"
              key="quantidademesidademaximacorte"
              :disabled="!acao"
              :v="$v.idademaxima"
            />
            <Input
              type="number"
              label="Idade máxima"
              v-else
              v-model.number="form.quantidadeanoidademaximacorte"
              key="quantidadeanoidademaxima"
              :disabled="!acao"
              :v="$v.idademaxima"
            />
            <Validator :v="$v.tipoidademaxima">
              <v-radio-group style="margin-top: 0;" row v-model="tipoidademaxima" :disabled="!acao">
                <v-radio
                  :ripple="false"
                  :label="form.quantidademesidademaximacorte > 1 ? 'Meses' : 'Mês'"
                  value="mes"
                />
                <v-radio
                  :label="form.quantidadeanoidademaximacorte > 1 ? 'Anos' : 'Ano'"
                  value="ano"
                />
              </v-radio-group>
            </Validator>
          </v-flex>

          <!-- Forma de aplicação da regra -->
          <v-flex>
            <span class="v-label">Forma de aplicação da regra</span>
            <Validator :v="$v.form.indicaformaaplicacaoregra">
              <v-radio-group
                style="margin-top: 0;"
                row
                v-model="form.indicaformaaplicacaoregra"
                :disabled="!acao"
              >
                <v-radio :ripple="false" label="Mensagem" value="M"/>
                <v-radio :ripple="false" label="Bloqueio" value="B"/>
              </v-radio-group>
            </Validator>
          </v-flex>
        </v-card-text>
      </v-card>
    </FormBasico>

    <BuscaEtapa ref="BuscaEtapa" @chosen="setarEtapa"></BuscaEtapa>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import repository from '@/repositories/RepositoryFactory.js';
import udias from '@/utils/dias';
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import {
  required,
  minValue,
  integer,
  requiredIf,
} from 'vuelidate/lib/validators';
import BuscaEtapa from '@/components/BuscaEtapa';

const corteRepo = repository.get('corteEtario');
const currentYear = new Date().getFullYear();

const formInicial = () => ({
  identificadorcorteetario: '',
  identificadoretapaescolar: 2,
  anoinicioregracorte: currentYear,
  diacorteetario: 30,
  mescorteetario: 6,
  quantidademesidademinimacorte: 0,
  quantidademesidademaximacorte: null,
  quantidadeanoidademinimacorte: null,
  quantidadeanoidademaximacorte: null,
  indicaformaaplicacaoregra: 'M',
});

const auxInicial = () => ({
  etapaescolar: 'a',
  codigoetapa: 'a',
});

export default {
  components: {
    BuscaSimplesApi,
    BuscaEtapa,
  },
  created() {
    this.$Progress.finish();
  },
  data() {
    return {
      currentYear,
      acao: '',
      form: formInicial(),
      buscarSelect: 'anoinicioregracorte',
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscaOptions: [
        { value: 'identificadorcorteetario', text: 'Código' },
        { value: 'anoinicioregracorte', text: 'Descrição' },
      ],
      etapaloading: false,
      formUltimo: {},
      aux: auxInicial(),
    };
  },
  validations() {
    let idademaxima = this.quantidademesidademinimacorte;
    if (this.tipoidademinima === 'mes' && this.tipoidademaxima === 'ano') {
      idademaxima = Math.ceil(this.quantidadeanoidademinimacorte / 12);
    }

    return {
      form: {
        identificadoretapaescolar: {
          required,
        },
        anoinicioregracorte: {
          required,
          integer,
          minValue: minValue(currentYear),
        },
        diacorteetario: {
          required,
          integer,
        },
        mescorteetario: {
          required,
          integer,
        },
        indicaformaaplicacaoregra: {
          required,
        },
        quantidademesidademinimacorte: {
          required: requiredIf(vm => vm.tipoidademinima === 'mes'),
          integer,
        },
        quantidadeanoidademinimacorte: {
          required: requiredIf(vm => vm.tipoidademinima === 'ano'),
          integer,
        },
        quantidademesidademaximacorte: {
          integer,
          minValue: minValue(idademaxima),
        },
        quantidadeanoidademaximacorte: {
          integer,
          minValue: minValue(idademaxima),
        },
      },
    };
  },
  methods: {
    novo() {
      this.acao = 'novo';
      this.form = formInicial();
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    async buscarEtapa() {
      this.etapaloading = true;
      await this.$refs.BuscaEtapa.open();
      this.etapaloading = false;
    },
    setarEtapa(etapa) {
      this.form.identificadoretapaescolar = etapa.identificadoretapaescolar;
      this.aux.etapaescolar = etapa.descricaoetapaescolar;
      this.aux.codigoetapa = etapa.codigoetapaescolar;
    },
    editar() {
      this.acao = 'editar';
    },
    excluir() {
      if (this.acao == 'novo') {
        this.form = formInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    cancelar() {
      this.form = formInicial();
      this.aux = auxInicial();
      this.acao = '';
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      try {
        const response = await (this.acao === 'novo' ? corteRepo.create(this.form) : corteRepo.save(this.form.identificadorcorteetario, this.form));

        this.acao = '';
        this.submitText = response.data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...response.data.results };
      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') {
          this.msgArrayError = error.response.data.errorMessage;
        }
        if (window.scrollY >= 250) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } finally {
        this.$v.$reset();
      }
    },
    encontrado(dados) {
      this.form = formInicial();
      this.form = { ...dados };
      this.formUltimo = { ...dados };
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },
  },
  computed: {
    meses() {
      return udias.meses.map((v, i) => ({
        value: i + 1,
        text: v,
      }));
    },
    dias() {
      const dias = [];
      const ndias = udias.diaPorMes(this.form.mescorteetario);
      for (let i = 1; i <= ndias; i++) {
        dias.push(i);
      }
      return dias.map(v => ({
        value: v,
        text: v,
      }));
    },
    tipoidademinima: {
      get() {
        if (this.form.quantidadeanoidademinimacorte !== null) return 'ano';
        return 'mes';
      },
      set() {
        [
          this.form.quantidademesidademinimacorte,
          this.form.quantidadeanoidademinimacorte,
        ] = [
          this.form.quantidadeanoidademinimacorte,
          this.form.quantidademesidademinimacorte,
        ];
      },
    },
    tipoidademaxima: {
      get() {
        if (this.form.quantidadeanoidademaximacorte !== null) return 'ano';
        return 'mes';
      },
      set() {
        [
          this.form.quantidademesidademaximacorte,
          this.form.quantidadeanoidademaximacorte,
        ] = [
          this.form.quantidadeanoidademaximacorte,
          this.form.quantidademesidademaximacorte,
        ];
      },
    },
  },
};
</script>

<style lang="scss">
.input-100 {
  width: 100%;
}
.field100 {
  width: 60%;
  @media screen and (max-width: "700px") {
    width: 100%;
  }
}
</style>
